// extracted by mini-css-extract-plugin
module.exports = {"navColumn":"Column_navColumn__333Bw","innerNavContainer":"Column_innerNavContainer__1lI4K","mainColumn":"Column_mainColumn__1hYCp"};